import React from 'react';
import type { RecoveryDay } from './types';
import { Pill } from './Pill';

interface Props {
  sleep: NonNullable<RecoveryDay['sleep']>;
}

function fmtHoursFromMinutes(min: number | null | undefined): string | null {
  if (min == null || min <= 0) return null;
  return `${(min / 60).toFixed(1)}h`;
}

function fmtPct(value: number | null | undefined): string | null {
  if (value == null) return null;
  // Sleep efficiency is stored as a fraction (0–1) when via Whoop, or a
  // 0–100 percent on some Terra-routed providers. Treat anything ≤ 1.5 as
  // a fraction and rescale; otherwise treat as already a percent.
  const pct = value <= 1.5 ? value * 100 : value;
  return `${Math.round(pct)}%`;
}

export function SleepDetail({ sleep }: Props) {
  return (
    <div className="grid grid-cols-2 gap-2">
      <Pill label="Duration" value={fmtHoursFromMinutes(sleep.total_minutes)} />
      <Pill label="Efficiency" value={fmtPct(sleep.efficiency)} />
      <Pill label="Deep" value={fmtHoursFromMinutes(sleep.deep_minutes)} />
      <Pill label="REM" value={fmtHoursFromMinutes(sleep.rem_minutes)} />
      <Pill
        label="Quality"
        value={sleep.quality_score != null ? `${Math.round(sleep.quality_score)}` : null}
      />
    </div>
  );
}
